import { Component, ChangeDetectorRef, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AuthenticationService, TestData } from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionSetService } from '../services/questionset.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { Overall_Result } from '../overall_result/overall_result.model';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSortModule, MatSort} from '@angular/material/sort';
import { MatDialog, MatDialogConfig } from "@angular/material";
import { Subscription } from 'rxjs';
import { CollegeService, Student_scheduleid } from '../services/College_name.service';



@Component({
  templateUrl: './individual_result.component.html',
  styleUrls: [ './individual_result.component.scss' ]
})

export class IndividualResultComponent implements OnInit{
  selectedCategory;
  subscription: Subscription;
  displayedColumns: string[] = ['S.No.','Section_Name','Category_Name','No_of_Correct_Answers','User_Start_Time','User_end_Time'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  student_id:Student_scheduleid={user_id:'',schedule_id:''}
  searchKey: string;
  dataSource: MatTableDataSource<any>;
  selectedCategoryindex: string;
  newAttribute: any = {};
  Question_Category: any;
  result: boolean;
  details: boolean;
  Category;
  Type;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  id;
  userAdmin: boolean;
  overall: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  individualresult: Array<Overall_Result> = [];
  report;

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  message: any;
  studentData: any;
  studentdata: any;
  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private qs: QuestionSetService,
              private testschedulerservice: TestSchedulerService,  private route: ActivatedRoute,
              changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,private collegeservice: CollegeService) {
  this.simpletest();
  this.mobileQuery = media.matchMedia('(max-width: 600px)');
  this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  this.mobileQuery.addListener(this._mobileQueryListener);
  }
  ngOnInit() {
  //     this.route.params.subscribe(params => {
  //     this.id = params['id'];
  // });
  //
      //this.getdata();

      this.individual_result();
  }



simpletest() {
this.testschedulerservice.test_scheduler(this.test).subscribe(
(data) => {

this.user = sessionStorage.getItem('user');
this.fname = sessionStorage.getItem('fname');

this.lname = sessionStorage.getItem('lname');


if (this.user === '2') {

this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = true;
this.userTestTaker = true;
this.details = true;
this.overall = true;
this.questionset = true;
this.scheduletest = true;
this.evaluate = true;
// this.result = data.results;
return this.result;
} else if ( this.user === '1') {
this.userAdmin = true;
this.userSuperAdmin = true;
this.userTestScheduler = true;
this.userTestTaker = true;
this.questionset = true;
this.details = true;
this.overall = true;
this.evaluate = true;
this.scheduletest = true;
// this.result = data.results;
return this.result;
} else if ( this.user === '3') {
this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = false;
this.userTestTaker = true;
this.questionset = true;
this.details = true;
this.overall = true;
this.evaluate = true;
this.scheduletest = true;
} else if ( this.user === '4') {
this.userAdmin = false;
this.userSuperAdmin = false;
this.userTestScheduler = false;
this.userTestTaker = false;
this.questionset = false;
this.details = false;
this.scheduletest = true;
this.evaluate = false;
this.overall = false;
}
},
err => {
console.error(err);
}
);
}

back(){
  this.router.navigate(['/overall_result']);
}

// getdata(){
//   this.subscription = this.collegeservice.getMessage().subscribe(
//     message => {
//       this.message = message;
//       this.studentData = message;
//
//       this.individual_result();
//       return this.studentData;

//     });

// }

individual_result() {
  this.studentdata=JSON.parse(sessionStorage.getItem('studentdata'));

  this.student_id.schedule_id =  this.studentdata.schedule_id;
  this.student_id.user_id =  this.studentdata.user_id;
  //
  this.collegeservice.individual_result(this.student_id).subscribe(
      (data) => {
        this.report = data.results;

        this.dataSource = new MatTableDataSource(this.report);
        this.dataSource.sort=this.sort;
        setTimeout(() => this.dataSource.paginator = this.paginator);

        //
        return this.report;
      },
      err => {
        console.error(err);
      }
    );
}
}



